import { WorkVersionArticleModel } from './WorkVersionArticleDto';
import { TerritoryModel } from './territory.model';
import { LanguageModel } from './language.model';
import { WorkVersionUsedModel } from './work-versions-used.model';
import { WorkVersionOriginModel } from './work-version-origin.model';
import { ReferentialEntityStateModel } from './referential-entity-state.model';

/**
 * Created by vsliwka on 20/04/2017.
 */
export class WorkVersionModel {
  public id: number;
  public title: string;
  public principal: boolean;
  public order = 0;
  public origin: WorkVersionOriginModel;
  public article: WorkVersionArticleModel;
  public articleId: number;
  public country: TerritoryModel;
  public used: WorkVersionUsedModel;
  public languageVersion: LanguageModel;
  // Denormalized field for display purpose only
  public restrictionTv: string;
  // Denormalized field for display purpose only
  public restrictionCine: string;
  public entityState: ReferentialEntityStateModel;
  public countryLabel: string;
  public isEpisode = false;

  constructor() {
    this.article = new WorkVersionArticleModel();
    this.origin = new WorkVersionOriginModel();
    this.country = new TerritoryModel();
    this.used = new WorkVersionUsedModel();
    this.countryLabel = '';
  }

  public fromJSON(json) {
    for (const propName in json) {
      if (json.hasOwnProperty(propName)) {
        this[propName] = json[propName];
      }
    }
    return this;
  }
}
